
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  statCard: {
    padding: theme.spacing(2),
    textAlign: 'center',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  value: {
    fontWeight: 'bold',
    fontSize: '2rem',
    marginBottom: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
  },
  blue: { color: '#2196f3' },
  green: { color: '#4caf50' },
  red: { color: '#f44336' },
  teal: { color: '#009688' },
  purple: { color: '#9c27b0' },
  orange: { color: '#ff9800' },
}));

function Stats({ summary }) {
  const classes = useStyles();

  const byTruckType = summary?.byTruckType || {};

  const stats = [
    { label: 'Bateas', value: byTruckType.BATEA || 0, color: classes.blue },
    { label: 'Ampliroll', value: byTruckType.AMPLIROLL || 0, color: classes.green },
    { label: 'Piso Caminante', value: byTruckType.PISO_CAMINANTE || 0, color: classes.red },
    { label: 'Camión Plano', value: byTruckType.CAMION_PLANO || 0, color: classes.orange },
    { label: 'Total Camiones', value: summary?.totalTrucks || 0, color: classes.teal },
    { label: 'Equivalente Bins', value: summary?.totalBinsEquivalent || 0, color: classes.purple },
    { label: 'Bins con Fruta', value: summary?.totalBinsWithFruit || 0, color: classes.purple },
    { label: 'Maxisacos', value: summary?.totalMaxisacos || 0, color: classes.purple },
    { label: 'Bins Vacíos', value: summary?.totalEmptyBins || 0, color: classes.purple },
  ];

  return (
    <Grid container spacing={3} style={{ marginBottom: '24px' }}>
      {stats.map((stat) => (
        <Grid item xs={12} sm key={stat.label}>
          <Paper className={classes.statCard}>
            <Typography className={classes.label} variant="caption">
              {stat.label}
            </Typography>
            <Typography className={`${classes.value} ${stat.color}`}>
              {stat.value}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

export default Stats;
